import { useTranslation } from 'react-i18next';

const useTitle = title => {
  const { t } = useTranslation();

  const defaultTitle = 'SAM Libro de Compras'
  title ? document.title = t(title) + ' | '+defaultTitle : document.title = defaultTitle 
};

export default useTitle